import { useMemo } from 'react';
import { validateAndConvertToSelf } from 'my-phr/utils/conversion';
import useConvertDistanceData from './useConvertDistanceData';

export function useGetUnit(data) {
  const { convertedValue } = useConvertDistanceData(data);
  const availableUnits = useMemo(() => {
    return data?.storyblock?.ranges?.units;
  }, [data]);

  const fallbackUnit = useMemo(() => {
    return availableUnits?.find((unit) => unit.code === data?.unit)
      ?.printSymbol;
  }, [availableUnits, data]);

  const unitPrintSymbol = validateAndConvertToSelf({
    unit: convertedValue?.unit,
    value: convertedValue?.value,
    molecularWeight: data?.storyblock?.molecularWeight,
    charge: data?.storyblock?.charge,
    fallbackUnit,
  }).unit;

  return { unitPrintSymbol };
}
